import comp from "./ResourceCreateEditModal";
export default comp;
